export default __webpack_public_path__ + "static/media/Dimsport-logo.d522b593.png";